<style lang="scss">
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/utils";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/colors";

  .button-cell {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    padding: utils.in_rem(8px);
  }
</style>

<script>
  import TD from "@sourcewhale/shared/svelte-design-system/components/molecules/Table/TD.svelte";
  import TR from "@sourcewhale/shared/svelte-design-system/components/molecules/Table/TR.svelte";
  import { fieldOperations } from "../../../../../../stores/fieldSettings";
  import FieldCheckbox from "./FieldCheckbox.svelte";
  import FieldLabel from "./FieldLabel.svelte";
  import UpdateDropdown from "./UpdateDropdown.svelte";

  export let field;
  export let type;

  $: fieldRestrictions = {
    isProtectedOnly: field.existsInProtectedOnly,
    noProtectedMapping: !field.mappings.protected,
  };

  $: selectedOption = field.isProtected ? "ifBlank" : "always";

  const toggleField = (fieldType) => {
    // Skip if field doesn't have mapping or is protected-only
    if (!field.existsInProtectedOnly && field.mappings[fieldType]) {
      fieldOperations.toggleField(type, field, fieldType);
    }
  };
</script>

<TR>
  <TD>
    <FieldLabel {field} />
  </TD>
  <TD>
    <FieldCheckbox
      checked={field.isDisplayed}
      disabled={fieldRestrictions.isProtectedOnly || field.isMandatory}
      isMandatoryRelated={field.isMandatory}
      onChange={() => toggleField("displayed")}
    />
  </TD>
  <TD>
    <FieldCheckbox
      checked={field.isMandatory}
      disabled={fieldRestrictions.isProtectedOnly}
      onChange={() => toggleField("mandatory")}
    />
  </TD>
  <TD>
    <UpdateDropdown
      {selectedOption}
      onSelect={(value) =>
        fieldOperations.setUpdateBehavior(type, field, value)}
      disabled={fieldRestrictions.noProtectedMapping}
    />
  </TD>
</TR>
